import React, { useState } from 'react';
import pageData from '../data/pages/footer2.json';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import BackToTop from './common/BackToTop';
import { Styles } from "./styles/footerTwo.js";
import { getAssetUrl } from '../helper/assets';
import { sendNewsletterEmail } from '../helper/emailService';

function FooterTwo() {
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');

    const validateEmail = (val) => {
        const trimmed = val.trim();
        if (!trimmed) return "Email address is required";
        if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(trimmed)) {
            return "Please enter a valid email address";
        }
        return "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMsg('');
        
        const err = validateEmail(email);
        if (err) {
            setEmailError(err);
            return;
        }

        setEmailError('');
        setIsSubmitting(true);

        try {
            await sendNewsletterEmail({ email: email.trim() });
            setSuccessMsg("Thank you for subscribing to our newsletter!");
            setEmail('');
            setTimeout(() => {
                setSuccessMsg('');
            }, 6000);
        } catch (error) {
            console.error("Newsletter submission error:", error);
            setEmailError("Failed to subscribe. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const Datas = pageData;

    return (
        <Styles>
            {/* Footer Two */}
            <footer className="footer2" style={{ backgroundImage: `url(${getAssetUrl(Datas.backgroundImage)})` }}>
                <Container>
                    <Row>
                        <Col md="3">
                            <div className="footer-logo-info">
                                <img src={getAssetUrl(Datas.logo)} alt="" className="img-fluid" />
                                <p>{Datas.aboutText}</p>
                                <ul className="list-unstyled">
                                    <li><i className="las la-map-marker"></i>{Datas.location}</li>
                                    <li><i className="las la-envelope"></i>{Datas.email}</li>
                                    <li><i className="las la-phone"></i>{Datas.phone}</li>
                                </ul>
                            </div>
                        </Col>
                        <Col md="3">
                            <div className="f-links">
                                <h5>{Datas.usefulLinksTitle}</h5>
                                <ul className="list-unstyled">
                                    {Datas.usefulLinks.map((item, i) => (
                                        <li key={i}><Link to={process.env.PUBLIC_URL + item.link}><i className="las la-angle-right"></i>{item.text}</Link></li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                        <Col md="3">
                            <div className="f-links">
                                <h5>{Datas.featuredCountriesTitle}</h5>
                                <ul className="list-unstyled">
                                    {(Datas.featuredCountries || []).map((item, i) => (
                                        <li key={i}><Link to={process.env.PUBLIC_URL + item.link}><i className="las la-angle-right"></i>{item.text}</Link></li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                        <Col md="3">
                            <div className="f-newsletter">
                                <h5>{Datas.newsletterTitle}</h5>
                                <p>{Datas.newsletterDesc}</p>

                                <form id="form4" className="form" onSubmit={handleSubmit} noValidate>
                                    <p className={`form-control ${emailError ? 'error' : successMsg ? 'success' : ''}`}>
                                        <input 
                                            type="email" 
                                            placeholder="Enter email here" 
                                            id="email4" 
                                            value={email}
                                            onChange={(e) => {
                                                setEmail(e.target.value);
                                                if (emailError) setEmailError('');
                                            }}
                                            disabled={isSubmitting}
                                        />
                                        <span className="input-msg4">{emailError}</span>
                                    </p>
                                    <button type="submit" disabled={isSubmitting}>
                                        {isSubmitting ? 'Sending...' : 'Submit'}
                                    </button>
                                    {successMsg && (
                                        <div style={{
                                            marginTop: '12px',
                                            fontSize: '13px',
                                            color: '#00a859',
                                            fontWeight: '500',
                                            background: 'rgba(0, 168, 89, 0.12)',
                                            border: '1px solid #00a859',
                                            borderRadius: '4px',
                                            padding: '8px 12px',
                                            lineHeight: '1.4'
                                        }}>
                                            <i className="las la-check-circle" style={{ marginRight: '6px', fontSize: '15px' }}></i>
                                            {successMsg}
                                        </div>
                                    )}
                                </form>
                            </div>
                        </Col>
                        <Col md="12">
                            <div className="copytext-area text-center">
                                <p dangerouslySetInnerHTML={{ __html: Datas.copyrightText }} />
                                <ul className="social list-unstyled list-inline">
                                    {Datas.socialLinks.map((social, i) => (
                                        <li className="list-inline-item" key={i}>
                                            <a href={social.link} target="_blank" rel="noopener noreferrer"><i className={social.iconClass}></i></a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>

                {/* Back To Top  */}
                <BackToTop />
            </footer>
        </Styles>
    );
}

export default FooterTwo;
